export const CONSTANT_KEYS = {
  AGE: 'age',
  CODE: 'code',
  NAME: 'name',
  WORDS: 'words',
  TEETH: 'teeth',
  SAMPLE: 'sample',
  WORDSET: 'wordset',
  WORDSET_EXACT: 'wordset_exact',
  ENTIRE_ROW: 'entire_row',
  NAME_RU: 'name_ru',
  NAME_EN: 'name_en',
  WORDS_RU: 'words_ru',
  WORDS_EN: 'words_en',
  PROFILE: 'profile',
  PROFILES: 'profiles',
  NAMES: 'names',
  LANGUAGE: 'language',
  SERVICE: 'service',
  SERVICES: 'services',
  LANGUAGE_NAME: 'language_name',
  LANGUAGE_ID: 'language_id',
  DIAGNOSE: 'diagnose',
  WORD_AFTER_CLEANING: 'word_after_cleaning',
  COMMENT: 'comment',
  PROFILE_NAME: 'profile_name',
  SERVICE_NAMES: 'service_names',
  SERVICE_NAME: 'service_name',
  CLEAN: 'clean',
  ID: 'id',
  CODING: 'coding',
  USERNAME: 'username',
  ACTIVE: 'is_active',
  ACCESS_LEVEL: 'access_level',
  AVAILABLE_PROFILES: 'available_profiles',
  DATA_LANGUAGE_ID: 'data_language_id',
  OFFSET: 'offset',
  LIMIT: 'limit',
  DEFAULT_PROFILE: 'default_profile',
};

export const DIAGNOSES_KEYS = {
  GROUP_MKB: 'group_mkb',
  CODE_MKB: 'code_mkb',
  NAME_RU: 'name_ru',
  NAME_EN: 'name_en',
  WORDS_RU: 'words_ru',
  WORDS_EN: 'words_en',
  CLIENT: 'client',
  REGION: 'region',
  DIAGNOSE: 'diagnose',
  SCORE: 'score',
};

export const MAPPINGS_KEYS = {
  CLIENT: 'client',
  SERVICE_NAME: 'service_name',
  CLASS_999: 'class_999',
  SEARCH_BAR: 'search_bar',
  ENCODING_TYPE: 'encoding_type',
  ENCODING: 'encoding',
  CLASS_5LVL: 'class_5lvl',
  RELATED_CODE: 'related_code',
  CLASS_5LVL_NAME: 'class_5lvl_name',
  RELATED_CODE_NAME: 'related_code_name',
};

export const REPLACEMENTS_KEYS = {
  COMMENT: 'comment',
  REPLACED: 'replaced',
  REPLACEMENT: 'replacement',
  REPLACEMENT_TYPE: 'replacement_type',
  OFFSET: 'offset',
  LIMIT: 'limit',
  LANGUAGE_ID: 'language_id',
};

export const CLASSIFICATION_KEYS = {
  CODES: 'codes',
  CODING: 'coding',
  SCORE: 'score',
  NAME: 'name',
  CLEANED_SERVICE_NAME: 'cleaned_service_name',
  NUMBER: 'number',
  NAMES: 'names',
  COLUMN: 'column',
  TASK_ID: 'task_id',
  NONDICT: 'nondict',
  KEY: 'key',
};

export const RELATIONS_KEYS = {
  CODE: 'code',
  NAME: 'name',
  RELATED_CODE: 'related_code',
  RELATED_CODE_NAME: 'related_code_name',
  PROFILE_ID: 'profile_id',
  LANGUAGE_ID: 'language_id',
  CODE_NAME: 'code_name',
  RELATION_TYPE: 'relation_type',
  PROFILES: 'profiles',
  PROFILE: 'profile',
  COEFFICIENT: 'coefficient',
  CODING: 'coding',
  RELATED_CODING: 'related_coding',
  COMMENT: 'comment',
};

export const MATCHING_KEYS = {
  SCORE: 'score',
  MATCH_TYPE: 'match_type',
  TASK_ID: 'task_id',
  COLUMN: 'column',
  COLUMN_2: 'column_2',
  TASK_TYPE: 'task_type',
  METHOD: 'method',
  GUARANTEE_LETTERS_TEXT: 'guarantee_letters_text',
  ELEM: 'elem',
  CROSS_ELEM: 'cross_elem',
  CODE_NUMBERS: 'code_numbers',
  GUARANTEE_LETTERS_APPROVE_SCORE: 'guarantee_letters_approve_score',
  MATCH_SCORE: 'match_score',
  CODE: 'code',
  CROSS_CODE: 'cross_code',
};
